// @ts-nocheck
import React, { useState, useEffect } from 'react';
import Button from '@/components/button';
import Breadcrumbs from '@/components/breadcrumbs';
import Search from '@/components/search';
import Table from '@/components/table';
import CellStatus from '@/components/cells/status-old';
import CellDate from '@/components/cells/date';
import CellBold from '@/components/cells/bold';
import CellTech from '@/components/cells/tech';
import CellWide from '@/components/cells/wide';
import CellCheckbox from '@/components/cells/checkbox';
import CellCurrency from '@/components/cells/currency';
import CellNumber from '@/components/cells/number';
import ColumnSelect from '@/components/column-select';
import KendoPager from '@/components/kendo/kendo-pager';
import Fetch from '@/utils/Fetch';
import Router from 'next/router';
import * as Enums from '@/utils/enums';
import Storage from '@/utils/storage';
import Helper from '@/utils/helper';
import UCS from '@/services/option/user-config-service';
import KendoCellStatus from '@/components/kendo/cells/kendo-cell-status';
import KendoCellNumber from '@/components/kendo/cells/kendo-cell-number';
import KendoCellCurrency from '@/components/kendo/cells/kendo-cell-currency';
import KendoCellDate from '@/components/kendo/cells/kendo-cell-date';
import KendoCellEmployee from '@/components/kendo/cells/kendo-cell-employee';
import KendoTable from '@/components/kendo/kendo-table';
import { createFileRoute } from '@tanstack/react-router'



function SupplierList() {

  const [columnState, setColumnState] = useState<any[]>([]);
  const [availableColumns, setAvailableColumns] = useState<any[]>([]);
  const [requiredColumns, setRequiredColumns] = useState<any[]>([]);
  const [selectedColumns, setSelectedColumns] = useState<any[]>([]);

  const [supplierResults, setSupplierResults] = useState([{}]);

  const [sortField, setSortField] = useState('');
  const [sortDirection, setSortDirection] = useState('');
  const [searching, setSearching] = useState(false);
  const [searchVal, setSearchVal] = useState('');
  const [ancillaryFilters, setAncillaryFilters] = useState({ IncludeDisabled: false });
  const [totalResults, setTotalResults] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const [filtersConfig, setFiltersConfig] = useState<any>(null);

  const handleAncillaryFilterChange = (result: any) => {
    if (result.reset) {
      setAncillaryFilters({ IncludeDisabled: false });
    } else {
      if (result.key == "IncludeDisabled") {
        setAncillaryFilters({ IncludeDisabled: result.checked });
      }
    }
  };

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

  const getAccessStatus = () => {
    let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  };

  const [pageSize, setPageSize] = useState(10);

  const pageSizeChanged = (size: any) => {
    setPageSize(size);
  };

  const pageChanged = (page: any) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    getAccessStatus();
    (async () => {
      const filtersConfigRes = await UCS.getPageFilters(Enums.ConfigurationSection.Supplier);
      const [, ancillaryDef, sortExpr, sortDir] = UCS.getFilterValues(filtersConfigRes, [], [], ["IncludeDisabled"], false);
      setFiltersConfig(filtersConfigRes);
      setAncillaryFilters(ancillaryDef);
      setSortField(sortExpr);
      setSortDirection(sortDir);

      const columnsRes = await Fetch.get({ url: '/Employee/ColumnMapping', params: { model: 'SupplierList' } });
      const cols = columnsRes.Results;
      setColumnState(cols);
      setAvailableColumns(cols.map((c: any) => c.Label));
      setRequiredColumns(cols.filter((c: any) => c.IsRequired).map((c: any) => c.Label));
      setSelectedColumns(cols.filter((c: any) => c.Show).map((c: any) => c.Label));
    })();
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace, "/");
    }
  }, [accessStatus]);

  useEffect(() => {
    if (currentPage == 1) {
      searchSuppliers();
    } else {
      setCurrentPage(1);
    }
  }, [sortField, sortDirection, ancillaryFilters, pageSize]);

  useEffect(() => {
    searchSuppliers();
  }, [currentPage]);

  function setSort(field: any) {
    setSortDirection(Helper.getSortDirection(field, sortField, sortDirection));
    setSortField(field);
  }

  const searchSuppliers = async () => {
    setSearching(true);

    const suppliers = await Fetch.post({
      url: `/Supplier/GetSuppliers`,
      params: {
        pageSize: pageSize,
        pageIndex: (currentPage - 1),
        searchPhrase: searchVal,
        IncludeClosed: ancillaryFilters["IncludeDisabled"],
        SortExpression: sortField,
        SortDirection: sortDirection,
        PopulateList: false,
      }
    });

    let filtersConfigTemp = { ...filtersConfig };
    UCS.updateFilters(filtersConfigTemp, null, ancillaryFilters, sortField, sortDirection);
    UCS.saveConfigDebounced(filtersConfigTemp);
    setFiltersConfig(filtersConfigTemp);

    setSupplierResults(suppliers.Results);
    setTotalResults(suppliers.TotalResults);

    setSearching(false);
  }

  const [selectedSupplier, setSelectedSupplier] = useState<any[]>([]);

  const columns = React.useMemo(
    () => columnState.filter((column: any) => column.Show == true).map(function (column: any) {
      let columnObject = {
        Header: column.Label,
        accessor: column.ColumnName,
        ColumnName: column.ColumnName,
        UserWidth: column.UserWidth
      };

      if (column.CellType != "none") {
        switch (column.CellType) {
          case 'select':
          case 'check':
            columnObject['accessor'] = (row: any) => { return { Code: row.Code, ID: row.ID } };
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellCheckbox value={value.Code} itemId={value.ID} key={value}
              selectedItems={selectedSupplier} setSelectedItems={setSelectedSupplier} />;
            break;
          case 'employee':
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellTech value={value} />;
            columnObject['KendoCell'] = (props: any) => <KendoCellEmployee {...props} employeesField="Employees" />;
            break;
          case 'date':
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellDate value={value} />;
            columnObject['KendoCell'] = (props: any) => <KendoCellDate {...props} />;
            break;
          case 'currency':
            columnObject['extraClasses'] = 'header-right-align';
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellCurrency value={value} />;
            columnObject['KendoCell'] = (props: any) => <KendoCellCurrency {...props} />;
            break;
          case 'int':
          case 'int?':
            columnObject['extraClasses'] = 'header-right-align';
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellNumber value={value} isDecimal={false} />;
            columnObject['KendoCell'] = (props: any) => <KendoCellNumber {...props} isDecimal={false} />;
            break;
          case 'decimal':
          case 'decimal?':
            columnObject['extraClasses'] = 'header-right-align';
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellNumber value={value} isDecimal={true} />;
            columnObject['KendoCell'] = (props: any) => <KendoCellNumber {...props} isDecimal={true} />;
            break;
          case 'status':
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellStatus value={value} valueEnum={columnObject.accessor} />;
            columnObject['KendoCell'] = (props: any) => <KendoCellStatus {...props} valueEnum={columnObject.accessor} />
            break;
          default:
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellBold value={value} />;
        }
      }

      return columnObject;
    }),
    [columnState, selectedSupplier]
  );

  function setColumn(selected: any) {
    let newColumns = [...selectedColumns];
    if (newColumns.includes(selected)) {
      newColumns = newColumns.filter((value: any) => { return value !== selected })
    } else {
      newColumns.push(selected);
    }
    setSelectedColumns(newColumns);

    const newState = columnState.map(function (column: any) {
      if (column.Label == selected) {
        column.Show = !column.Show;
      }
      return column;
    });
    setColumnState(newState);
    columnMappingPut(newState);
  }

  // for table resize columns
  async function resetColumnWidths() {
    const newState = columnState.map(function (column: any) {
      column.UserWidth = null;
      return column;
    });
    setColumnState(newState);
    columnMappingPut(newState);
  }

  async function onColumnResize(columnName: any, width: any, columnNamesAndWidths: any) {
    const newState = columnState.map(function (column: any) {
      if (column.ColumnName === columnName) {
        column.UserWidth = width;
      } else if (columnNamesAndWidths) {
        let match = columnNamesAndWidths.find((x: any) => x.columnName === column.ColumnName);
        if (match) {
          column.UserWidth = match.width;
        }
      }
      return column;
    });
    setColumnState(newState);
    columnMappingPut(newState);
  }
  // for table resize columns

  async function setReorder(updatedOptions: any) {

    const newState = updatedOptions.map((item: any, index: any) => {
      let column = columnState.find((x: any) => x.Label == item);
      column.Order = index;
      return column;
    });

    setAvailableColumns(updatedOptions);
    setColumnState(newState);

    columnMappingPut(newState);
  }

  async function columnMappingPut(newState: any) {
    await Fetch.put({
      url: '/Employee/ColumnMapping',
      params: {
        ColumnMappings: newState,
        model: 'SupplierList',
      }
    });
  }

  function rowClick(row: any) {
    Helper.nextRouter(Router.push, '/supplier/[id]', `/supplier/${row.original.ID}`);
  }

  const createSupplier = () => {
    Helper.nextRouter(Router.push, "/supplier/create");
  };

  return (
    <div className="list-container">
      <div className="row">
        <div className="title">
          <Breadcrumbs currPage={{ text: 'Suppliers', link: '/supplier/list', type: 'list' }} />
        </div>
        <Button disabled={accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess}
          text="Create" icon="plus-circle" extraClasses="fit-content no-margin" onClick={createSupplier} />
      </div>

      <div className="row end">
        <div className="search-container">
          <Search
            placeholder="Search supplier name"
            resultsNum={supplierResults.length}
            searchVal={searchVal}
            setSearchVal={setSearchVal}
            searchFunc={searchSuppliers}
            ancillaryFilters={{
              IncludeDisabled: [{ type: Enums.ControlType.Switch, label: 'Include disabled suppliers' }],
            }}
            setAncillaryFilters={handleAncillaryFilterChange}
            filtersConfig={filtersConfig}
          />
        </div>
        <div className="row end">
          <ColumnSelect options={availableColumns} selected={selectedColumns} requiredColumns={requiredColumns} setColumn={setColumn} setReorder={setReorder}
            resetColumnWidths={resetColumnWidths} />
        </div>
      </div>

      <div className={"no-items" + (supplierResults.length == 0 ? " no-items-visible" : "")}>
        <div className={"loading-overlay" + (searching ? " loading-overlay-visible" : "")}>
          <div className="loader"></div>
        </div>
        <img src="/job-folder.svg" alt="Folder" />
        <h3>No Supplier found</h3>
        <p>If you can't find a Supplier, try another search or create a new one.</p>
        <a href="/supplier/create"><img src="/icons/plus-circle-blue.svg" alt="plus" /> Add new Supplier</a>
        <img className="wave" src="/wave.svg" alt="wave" />
      </div>

      {/* <div className={"table-container" + (supplierResults.length != 0 ? " table-container-visible" : "")}>
        <div className={"loading-overlay" + (searching ? " loading-overlay-visible" : "")}>
          <div className="loader"></div>
        </div>
        <Table actions={[
          { text: "Edit", icon: "edit", function: (row) => Helper.nextRouter(Router.push, '/supplier/[id]', `/supplier/${row.ID}`) },
        ]}
          columns={columns} data={supplierResults} setSort={setSort} sortField={sortField} sortDirection={sortDirection} rowClick={rowClick} />
      </div> */}

      {supplierResults.length != 0 ? <KendoTable
        searching={searching}
        actions={[
          { text: "Edit", icon: "edit", function: (row: any) => Helper.nextRouter(Router.push, '/supplier/[id]', `/supplier/${row.ID}`) },
        ]}
        columns={columns}
        data={supplierResults}
        rowClick={rowClick}
        setSort={setSort}
        sortField={sortField}
        sortDirection={sortDirection}
        type="Supplier"
        // for table resize columns
        onColumnResize={onColumnResize}
        // for table resize columns
        canSelectItems={true}
        selectedItems={selectedSupplier}
        setSelectedItems={setSelectedSupplier}
        heightOffset={295}
        highlightColumnName="Code"
      /> : ""}

      <KendoPager pageSizeChanged={pageSizeChanged} pageChanged={pageChanged} totalResults={totalResults} searchValue={searchVal} parentPageNumber={currentPage} />

      <style jsx>{`
        .column {
          width: 100%;
        }
        .column-margin {
          margin-left: 24px;
        }
        .button-container {
          flex-shrink: 0;
          width: 12rem;
        }
        .button-container :global(.button){
          margin-top: 0.5rem;
        }
        .row {
          display: flex;
          justify-content: space-between;
        }
        .end {
          align-items: flex-end;
        }
        .row.top-gap {
          margin-top: 2.5rem;
        }
        .search-container :global(.search) {
          width: 528px;
        }
        a {
          text-decoration: none;
        }
      `}</style>
    </div>
  );
}

export default SupplierList;

export const Route = createFileRoute('/_authenticated/supplier/list')({ component: SupplierList })
